import type { ConnectionPermission } from '../types/settings.types.js';

export interface SqlClassification {
    operation: ConnectionPermission | 'dangerous';
    normalized: string;
    reason?: string;
}

export class ConnectSqlSafetyService {
    classify(sql: string): SqlClassification {
        const normalized = sql.trim().replace(/\s+/g, ' ').toUpperCase();
        if (!normalized) {
            return { operation: 'dangerous', normalized, reason: 'Empty SQL' };
        }

        if (this.hasMultipleStatements(normalized)) {
            return {
                operation: 'dangerous',
                normalized,
                reason: 'Multi-statement SQL is blocked by default',
            };
        }

        if (this.startsWithAny(normalized, ['SELECT ', 'SHOW ', 'DESCRIBE ', 'EXPLAIN ', 'WITH '])) {
            return { operation: 'read', normalized };
        }
        if (this.startsWithAny(normalized, ['INSERT ', 'UPDATE ', 'UPSERT ', 'REPLACE '])) {
            return { operation: 'write', normalized };
        }
        if (this.startsWithAny(normalized, ['DELETE ', 'TRUNCATE '])) {
            return { operation: 'delete', normalized };
        }
        if (this.startsWithAny(normalized, ['CREATE ', 'ALTER ', 'DROP ', 'RENAME '])) {
            return { operation: 'schema', normalized };
        }

        return {
            operation: 'dangerous',
            normalized,
            reason: 'Unknown SQL operation',
        };
    }

    private startsWithAny(value: string, prefixes: string[]): boolean {
        return prefixes.some((prefix) => value.startsWith(prefix));
    }

    private hasMultipleStatements(normalized: string): boolean {
        const trimmed = normalized.endsWith(';') ? normalized.slice(0, -1) : normalized;
        return trimmed.includes(';');
    }
}

